import { useState, useCallback } from 'react';
import { bookingsApi } from '../api/bookingsApi';
import type { BookingResponse } from '../types/booking.types';

interface UseRescheduleBookingReturn {
  isRescheduling: boolean;
  error: string | null;
  reschedule: (bookingId: string, newStartTime: Date) => Promise<BookingResponse | null>;
  clearError: () => void;
}

export function useRescheduleBooking(): UseRescheduleBookingReturn {
  const [isRescheduling, setIsRescheduling] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reschedule = useCallback(
    async (bookingId: string, newStartTime: Date): Promise<BookingResponse | null> => {
      try {
        setIsRescheduling(true);
        setError(null);
        const result = await bookingsApi.reschedule(bookingId, newStartTime.toISOString());
        return result;
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to reschedule booking';
        setError(message);
        return null;
      } finally {
        setIsRescheduling(false);
      }
    },
    []
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    isRescheduling,
    error,
    reschedule,
    clearError,
  };
}
